<template>
    <div class="table">
        <el-table :data="datas" style="width: 100%" border>
            <el-table-column width="90" align="center" label="日期" prop="operateDay"></el-table-column>
            <!-- 第一天 -->
            <el-table-column align="center" :label="day[0]">
                <el-table-column min-width="20%" align="center" label="2" property="breatheAndRemarks1">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks1"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6" property="breatheAndRemarks2">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks2"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10" property="breatheAndRemarks3">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks3"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14" property="breatheAndRemarks4">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks4"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18" property="breatheAndRemarks5">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks5"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22" property="breatheAndRemarks6">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks6"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 第二天 -->
            <el-table-column align="center" :label="day[1]">
                <el-table-column min-width="20%" align="center" label="2" property="breatheAndRemarks7">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks7"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6" property="breatheAndRemarks8">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks8"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10" property="breatheAndRemarks9">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks9"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14" property="breatheAndRemarks10">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks10"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18" property="breatheAndRemarks11">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks11"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22" property="breatheAndRemarks12">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks12"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 第三天-->
            <el-table-column align="center" width="100" :label="day[2]">
                <el-table-column min-width="20%" align="center" label="2" property="breatheAndRemarks13">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks13"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6" property="breatheAndRemarks14">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks14"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10" property="breatheAndRemarks15">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks15"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14" property="breatheAndRemarks16">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks16"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18" property="breatheAndRemarks17">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks17"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22" property="breatheAndRemarks18">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks18"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 第四天-->
            <el-table-column align="center" width="100" :label="day[3]">
                <el-table-column min-width="20%" align="center" label="2" property="breatheAndRemarks19">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks19"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6" property="breatheAndRemarks20">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks20"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10" property="breatheAndRemarks21">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks21"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14" property="breatheAndRemarks22">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks22"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18" property="breatheAndRemarks23">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks23"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22" property="breatheAndRemarks24">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks24"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 第五天-->
            <el-table-column align="center" width="100" :label="day[4]">
                <el-table-column min-width="20%" align="center" label="2" property="breatheAndRemarks25">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks25"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6" property="breatheAndRemarks26">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks26"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10" property="breatheAndRemarks27">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks27"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14" property="breatheAndRemarks28">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks28"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18" property="breatheAndRemarks29">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks29"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22" property="breatheAndRemarks30">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks30"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 第六天-->
            <el-table-column align="center" width="100" :label="day[5]">
                <el-table-column min-width="20%" align="center" label="2" property="breatheAndRemarks31">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks31"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6" property="breatheAndRemarks32">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks32"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10" property="breatheAndRemarks33">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks33"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14" property="breatheAndRemarks34">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks34"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18" property="breatheAndRemarks35">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks35"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22" property="breatheAndRemarks36">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks36"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 第七天-->
            <el-table-column align="center" width="100" :label="day[6]">
                <el-table-column min-width="20%" align="center" label="2">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks37"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="6">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks38"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="10">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks39"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="14">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks40"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="18">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks41"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="20%" align="center" label="22">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breatheAndRemarks42"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    props: ['day', 'datas'],
    data() {
        return {}
    },

    methods: {
    }
}
</script>

